import { CommonModule } from '@angular/common';
import { Component, Input, OnChanges, OnInit, ViewChild } from '@angular/core';
import { ChartComponent, NgApexchartsModule } from 'ng-apexcharts';
import { ChartOptions } from '../../../model/line-chart/chart-options';
import {
  LineChartModel,
  LineChartPoint,
} from '../../../model/line-chart/line-chart-model';

@Component({
  selector: 'app-line-graph-chart',
  templateUrl: 'line-chart-graph.component.html',
  styleUrls: ['line-chart-graph.component.scss'],
  standalone: true,
  imports: [CommonModule, NgApexchartsModule],
})
export class LineChartGraphComponent implements OnInit, OnChanges {
  @Input() data: LineChartModel;

  @ViewChild('chart') chart: ChartComponent;
  public chartOptions: Partial<ChartOptions>;

  isDataAvailable: boolean = false;

  constructor() {}

  ngOnInit() {
    this.initializeChart();
  }

  ngOnChanges() {
    this.initializeChart();
  }

  private initializeChart() {
    this.isDataAvailable = false;
    this.chartOptions = this.getDefaultChartOptions();

    if (!this.data || !this.data.series || this.data.series.length === 0) {
      this.chartOptions.series = [];
      this.chartOptions.xaxis.categories = [];
      return;
    }

    this.isDataAvailable = true;

    // Chart title
    this.chartOptions.title.text = this.data?.title || 'No data provided';

    this.chartOptions.xaxis.categories = this.data.series[0].data.map(
      (point) => point.label
    );

    for (let i = 0; i < this.data.series.length; i++) {
      const series = this.data.series[i];
      const seriesData: LineChartPoint[] = series.data;
      const seriesValues: number[] = seriesData.map((point) => point.value);
      this.chartOptions.series.push({
        name: series.label,
        data: seriesValues,
        color: series.color,
      });
    }
  }

  private getDefaultChartOptions(): Partial<ChartOptions> {
    return {
      series: [],
      chart: {
        type: 'line',
        height: 350,
        width: '100%',
        toolbar: {
          show: false,
        },
        zoom: {
          enabled: false,
        },
      },
      dataLabels: {
        enabled: false,
      },
      stroke: {
        curve: 'smooth',
      },
      title: {
        text: '',
        align: 'left',
      },
      grid: {
        strokeDashArray: 10,
      },
      xaxis: {
        categories: [],
        labels: {
          show: true,
          offsetX: 0,
          style: {
            colors: '#000',
            fontSize: '0.8em',
            fontWeight: '200',
            fontFamily: 'RFEBM',
          },
        },
        tooltip: {enabled: false}
      },
      yaxis: {
        forceNiceScale: true,
      },
      options: {
        legend: {
          show: true,
          position: 'top',
          inverseOrder: true,
          horizontalAlign: 'left',
          floating: false,
          fontSize: '1em',
          fontFamily: 'RFEBM',
        },
        tooltip: {
          enabled: true,
          style: {
            fontSize: '1em',
            fontFamily: 'RFEBM',
          },
        },
      },
    };
  }
}
